__turbopack_context__.v({
  "buttonTheme": "small-loader-module__VPNZpq__buttonTheme",
  "circular": "small-loader-module__VPNZpq__circular",
  "dash": "small-loader-module__VPNZpq__dash",
  "loaderWrapper": "small-loader-module__VPNZpq__loaderWrapper",
  "path": "small-loader-module__VPNZpq__path",
  "rotate": "small-loader-module__VPNZpq__rotate",
});
